<template>
  <div class="login">
    <div v-if="loggingIn" class="loader loader-positioning" />
    <div class="flex-wrapper">
      <div class="content-wrapper">
        <MaintenanceBanner />
        <div class="content">
          <h1>Sign in:</h1>
          <form v-on:submit.prevent="loginField" id="login-form">
            <label for="email">Email:</label>
            <input v-model="loginFieldEmail" type="text" id="email" />
            <label for="password">Password:</label>
            <input v-model="loginFieldPassword" type="password" id="password" />
            <input type="submit" value="Submit" />
          </form>
          <div id="login-error-display">
            <span v-if="localLoginError">{{ calculatedError }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { AxiosResponse } from "axios";
import { Component, Vue } from "vue-property-decorator";

import { getStatus, maintenanceInfo } from "@/helpers/maintenance";

import MaintenanceBanner from "@/components/MaintenanceBanner.vue";

@Component({
  components: {
    MaintenanceBanner
  }
})
export default class UserDetail extends Vue {
  public loginFieldEmail = "";
  public loginFieldPassword = "";
  public localLoginError = "";
  public loggingIn = false;

  public isMaintenance = false;
  public maintenanceInfo = maintenanceInfo;

  mounted(): void {
    this.checkToken().catch(() => {
      this.loggingIn = false;
    });

    getStatus()
      .then(status => {
        this.isMaintenance = status;
      })
      .catch(() => {
        this.isMaintenance = false;
      });
  }

  get calculatedError(): string {
    // Made the first letter uppercase.
    return (
      this.localLoginError.charAt(0).toUpperCase() +
      this.localLoginError.slice(1)
    );
  }

  async checkToken(): Promise<void> {
    const response = await this.$axios.post("/login/joomla");

    if (response && response.data) {
      this.$store.commit("setToken", response.data.token);
      this.loggingIn = false;
      this.$axios.defaults.headers.common.Authorization =
        "Bearer " + localStorage.getItem("authenticationToken");
      this.$router.push("/rma/create");
    }
  }

  async loginField(): Promise<void> {
    this.loggingIn = true;
    await this.$axios
      .post("/login", {
        email: this.loginFieldEmail,
        password: this.loginFieldPassword
      })
      .then((response: AxiosResponse) => {
        this.$store.commit("setToken", response.data.token);
        this.loggingIn = false;
        this.$axios.defaults.headers.common.Authorization =
          "Bearer " + localStorage.getItem("authenticationToken");
        this.$router.push("/rma/create");
      })
      .catch(error => {
        this.loggingIn = false;
        this.localLoginError = error.response
          ? error.response.data.error
          : error.message;
      });
  }
}
</script>

<style scoped>
.main {
  background-color: white;
  padding: 2ex;
  width: 80%;
  margin: 0 auto;
  box-shadow: gray 3px 3px 10px;
  border-radius: 2px;
}

.flex-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 95vh;
}

#middle-grid {
  display: grid;
  grid-template-columns: auto auto;
}

.content-wrapper {
  border: 1px solid lightgray;
}

.content {
  margin: 2ex;
  padding: 2ex 6ex;
  border-radius: 1px;
  text-decoration: none;
  color: black;
  font-family: "Roboto", sans-serif;
  width: 50vw;
  min-width: 200px;
  max-width: 400px;
}

.hrefButton {
  padding: 1ex;
  background-color: #da6f38;
  border-radius: 2px;
  color: white;
  text-decoration: none;
  font-weight: bold;
  float: right;
}

.loader {
  border: 16px solid #f3f3f3;
  /* Light grey */
  border-top: 16px solid #da6f38;
  /* Blue */
  border-radius: 50%;
  width: 120px;
  height: 120px;
  animation: spin 2s linear infinite;
}

.loader-positioning {
  position: absolute;
  top: calc(30vh - 60px);
  left: calc(50vw - 60px);
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.big-link {
  color: #da6f38;
  font-weight: bold;
  text-decoration: none;
}

.small-link {
  color: #da6f38;
  font-size: 1em;
  font-weight: bold;
  text-decoration: none;
}

#login-form {
  display: grid;
  grid-template-columns: auto;
  grid-gap: 10px;
  font-size: 1.2em;
}

#login-form input {
  width: 100%;
  font-size: 1em;
  padding: 1ex;
  border: 1px solid lightgray;
  border-radius: 2px;
  box-sizing: border-box;
}

#login-form input[type="submit"] {
  background-color: #da6f38;
  color: white;
  border: none;
  border-radius: 2px;
  padding: 1ex;
  font-weight: bold;
  cursor: pointer;
}

#login-form input[type="submit"]:hover {
  background-color: #c65f2f;
}

#login-error-display {
  color: #da6f38;
  font-size: 1em;
  padding-top: 1.8ex;
  font-weight: bold;
}
</style>
